import { render, staticRenderFns } from "./withBlack.vue?vue&type=template&id=037d4dec&scoped=true"
import script from "./withBlack.vue?vue&type=script&lang=js"
export * from "./withBlack.vue?vue&type=script&lang=js"
import style0 from "./withBlack.vue?vue&type=style&index=0&id=037d4dec&prod&lang=less"
import style1 from "./withBlack.vue?vue&type=style&index=1&id=037d4dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d4dec",
  null
  
)

export default component.exports